import { createStyles, makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    add: {
      marginTop: 8*2,
      marginBottom: 8*2,
    },
    button: {
      textTransform: 'none',
    },
    card: {
      minWidth: 275,
      position: 'relative',
      cursor: 'pointer',
      '&:not(:first-child)': {
        marginTop: 8*1,
      },
    },
    container: {
      backgroundColor: 'rgb(238, 238, 238)',
      paddingTop: 80,
      margin: `0 ${8*3}px`,
      '& > div[role=progressbar]': {
        position: 'absolute',
        top: 60,
        left: 0,
        width: '100%',
      },
    },
    form: {
      backgroundColor: '#fff',
      display: 'grid',
      gridGap: `${8*3}px`,
      gridTemplateColumns: '80%',
      justifyContent: 'center',
      padding: `${8*10}px 0 ${8*2}px`,

      '& > div[role=progressbar]': {
        position: 'absolute',
        top: 60,
        left: 0,
        width: '100%',
      },
    },
    header: {
      display: 'flex',
    },
    list: {
      padding: 0,
      margin: 0,
    },
    title: {
      fontSize: 14,
      margin: '0 0 8px 0',
    },
  }),
);
